import { render, staticRenderFns } from "./ApplicationConfirmation.vue?vue&type=template&id=66b3b851&scoped=true&"
import script from "./ApplicationConfirmation.vue?vue&type=script&lang=ts&"
export * from "./ApplicationConfirmation.vue?vue&type=script&lang=ts&"
import style0 from "./ApplicationConfirmation.less?vue&type=style&index=0&id=66b3b851&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b3b851",
  null
  
)

export default component.exports